// scoopOS
require('../../vendor/rmts/scoop-os/resources/js/scoop-os-vue');

Vue.component('selected-media-widget', require('./components/navigation-widgets/SelectedMediaWidget').default);
Vue.component('edit-media-flags', require('./components/navigation-widgets/EditMediaFlags').default);

// Components
Vue.component('assign-media-to-model', require('./components/AssignMediaToModel').default);
Vue.component('assign-media-to-format-productgroup', require('./components/AssignMediaToFormatProductgroup').default);
Vue.component('global-layout-icon-media-flag-warning', require('./components/global-layout-icons/MediaFlagWarning').default);

// Media filter
Vue.component('media-filter-product-name', require('./components/mediaFilter/Product').default);
Vue.component('media-filter-collection-name', require('./components/mediaFilter/Collection').default);
Vue.component('media-filter-productgroup-name', require('./components/mediaFilter/Productgroup').default);
Vue.component('media-filter-saison-name', require('./components/mediaFilter/Saison').default);
Vue.component('media-filter-color-name', require('./components/mediaFilter/Color').default);
Vue.component('media-filter-material-name', require('./components/mediaFilter/Material').default);
Vue.component('media-filter-stone-name', require('./components/mediaFilter/Stone').default);
Vue.component('media-filter-perspective-name', require('./components/mediaFilter/Perspective').default);
Vue.component('media-filter-engravable-name', require('./components/mediaFilter/Engravable').default);
Vue.component('product-size-filter', require('./components/ProductSizeFilter').default);

// Components
Vue.component('found-discontinued-articles', require('./components/ModelSelector/FoundDiscontinuedArticles').default);
Vue.component('found-product', require('./components/ModelSelector/FoundProduct').default);
Vue.component('missing-product', require('./components/ModelSelector/MissingProduct').default);
Vue.component('add-to-professionals-portal', require('../../ProfessionalsPortal/resources/js/components/AddMediaToProfessionalsPortal').default);
Vue.component('publish-media', require('./components/PublishMedia').default);

Vue.component('portal-ecom-warning', require('./components/PortalEcomWarning').default);

Vue.component('img-lazy', require('../../vendor/rmts/scoop-os/resources/js/components/ImgLazy').default);
